<template>
	<div class="pzhc">
		<div class="top">
			<div class="cardK">
				<div class="card">
					<div class="titleK">
						<div class="title">
							综合巡逻概览（{{getSelect(tabIndex1)}}）
						</div>
					</div>
					<el-menu :default-active="tabIndex1" @select="tabIndex1 = $event" class="el-menu-demo"
						mode="horizontal" background-color="transparent" text-color="#FFF" active-text-color="#3ED4EB">
						<el-menu-item :index="0">全部</el-menu-item>
						<el-menu-item :index="1">六月</el-menu-item>
						<el-menu-item :index="2">七月</el-menu-item>
						<el-menu-item :index="3">八月</el-menu-item>
					</el-menu>
					<div class="content contentZ1">
						<div class="gsItem">
							<div class="gsTitle">
								<span>任务总数</span>
								<img src="@/assets/pzhc/1.png" alt="">
							</div>
							<div class="num">
								{{tabValue1[tabIndex1].value1.v1}}
							</div>
							<div class="gsInners">
								<div class="gsItemIn">
									<p>同比</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue1[tabIndex1].value1.v2}}%</div>
								</div>
								<div class="gsItemIn">
									<p>环比</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue1[tabIndex1].value1.v3}}%</div>
								</div>
							</div>
						</div>
						<div class="gsItem">
							<div class="gsTitle">
								<span>任务完成数</span>
								<img src="@/assets/pzhc/2.png" alt="">
							</div>
							<div class="num">
								{{tabValue1[tabIndex1].value2.v1}}
							</div>
							<div class="gsInners">
								<div class="gsItemIn">
									<p>同比</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue1[tabIndex1].value2.v2}}%</div>
								</div>
								<div class="gsItemIn">
									<p>环比</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue1[tabIndex1].value2.v3}}%</div>
								</div>
							</div>
						</div>
						<div class="gsItem">
							<div class="gsTitle">
								<span>完成率</span>
								<img src="@/assets/pzhc/3.png" alt="">
							</div>
							<div class="num">
								{{tabValue1[tabIndex1].value3.v1}}%
							</div>
							<div class="gsInners">
								<div class="gsItemIn">
									<p>较上季度</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue1[tabIndex1].value3.v2}}%</div>
								</div>
							</div>
						</div>
						<el-popover placement="right" width="600" trigger="click" style="width: 48%;">
							<el-table :data="tabValue1[tabIndex1].value4.v3">
								<el-table-column width="300" property="label" label="任务名称"></el-table-column>
								<el-table-column width="200" property="taskNo" label="任务编号"></el-table-column>
								<el-table-column width="100" property="status" label="状态"></el-table-column>
							</el-table>
							<div class="gsItem active" slot="reference" style="width: 100%;height: calc(100% - 20px);">
								<div class="gsTitle">
									<span>逾期率</span>
									<img src="@/assets/pzhc/4.png" alt="">
								</div>
								<div class="num">
									{{tabValue1[tabIndex1].value4.v1}}%
								</div>
								<div class="gsInners">
									<div class="gsItemIn ">
										<p>较上季度</p>
										<div class="success"><img class="jiantou" src="@/assets/up.png"
												alt="" />{{tabValue1[tabIndex1].value4.v2}}%
										</div>
									</div>
								</div>
							</div>
						</el-popover>

					</div>
				</div>
			</div>
			<div class="cardK">
				<el-menu :default-active="tabIndex2" @select="setContent" class="el-menu-demo"
					mode="horizontal" background-color="transparent" text-color="#FFF" active-text-color="#3ED4EB">
					<el-menu-item :index="0">全部</el-menu-item>
					<el-menu-item :index="1">六月</el-menu-item>
					<el-menu-item :index="2">七月</el-menu-item>
					<el-menu-item :index="3">八月</el-menu-item>
				</el-menu>
				<div class="card">
					<div class="chartList">
						<div class="pzY">
							<div class="title">
								保安巡逻任务（{{getSelect(tabIndex2)}}）
							</div>
							<div class="chart" id="chart1" ref="chart1"></div>
							<div class="pzYlist">
								<div class="item" v-for="(item,index) in chart1Options.series[0].data" :key="index">
									<template v-if="item.name != '未完成'">
										<i :style="{background: item.itemStyle.color}"></i>
										<span class="name">{{item.name}}</span>
										<div class="value">{{item.value}}</div>
									</template>
									<template v-else>
										<el-popover placement="top" width="600" trigger="click">
											<el-table :data="chart1Options.tableValue">
												<el-table-column width="300" property="label"
													label="任务名称"></el-table-column>
												<el-table-column width="200" property="taskNo"
													label="任务编号"></el-table-column>
												<el-table-column width="100" property="status"
													label="状态"></el-table-column>
											</el-table>
											<div style="display: flex;flex-direction: row;align-items: center;padding: 0;cursor: pointer;"
												slot="reference">
												<i :style="{background: item.itemStyle.color}"></i>
												<span class="name">{{item.name}}</span>
												<div class="value">{{item.value}}</div>
											</div>
										</el-popover>
									</template>
								</div>
							</div>
						</div>
						<div class="hr"></div>
						<div class="pzY">
							<div class="title">
								保洁巡逻任务（{{getSelect(tabIndex2)}}）
							</div>
							<div class="chart" id="chart2" ref="chart2"></div>
							<div class="pzYlist">
								<div class="item" v-for="(item,index) in chart2Options.series[0].data" :key="index">
									<template v-if="item.name != '未完成'">
										<i :style="{background: item.itemStyle.color}"></i>
										<span class="name">{{item.name}}</span>
										<div class="value">{{item.value}}</div>
									</template>
									<template v-else>
										<el-popover placement="top" width="600" trigger="click">
											<el-table :data="chart2Options.tableValue">
												<el-table-column width="300" property="label"
													label="任务名称"></el-table-column>
												<el-table-column width="200" property="taskNo"
													label="任务编号"></el-table-column>
												<el-table-column width="100" property="status"
													label="状态"></el-table-column>
											</el-table>
											<div style="display: flex;flex-direction: row;align-items: center;padding: 0;cursor: pointer;"
												slot="reference">
												<i :style="{background: item.itemStyle.color}"></i>
												<span class="name">{{item.name}}</span>
												<div class="value">{{item.value}}</div>
											</div>
										</el-popover>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="chartList">
						<div class="pzY">
							<div class="title">
								客服巡逻任务（{{getSelect(tabIndex2)}}）
							</div>
							<div class="chart" id="chart3" ref="chart3"></div>
							<div class="pzYlist">
								<div class="item" v-for="(item,index) in chart3Options.series[0].data" :key="index">
									<template v-if="item.name != '未完成'">
										<i :style="{background: item.itemStyle.color}"></i>
										<span class="name">{{item.name}}</span>
										<div class="value">{{item.value}}</div>
									</template>
									<template v-else>
										<el-popover placement="top" width="600" trigger="click">
											<el-table :data="chart3Options.tableValue">
												<el-table-column width="300" property="label"
													label="任务名称"></el-table-column>
												<el-table-column width="200" property="taskNo"
													label="任务编号"></el-table-column>
												<el-table-column width="100" property="status"
													label="状态"></el-table-column>
											</el-table>
											<div style="display: flex;flex-direction: row;align-items: center;padding: 0;cursor: pointer;"
												slot="reference">
												<i :style="{background: item.itemStyle.color}"></i>
												<span class="name">{{item.name}}</span>
												<div class="value">{{item.value}}</div>
											</div>
										</el-popover>
									</template>
								</div>
							</div>
						</div>
						<div class="hr"></div>
						<div class="pzY">
							<div class="title">
								工程巡逻任务（{{getSelect(tabIndex2)}}）
							</div>
							<div class="chart" id="chart4" ref="chart4"></div>
							<div class="pzYlist">
								<div class="item" v-for="(item,index) in chart4Options.series[0].data" :key="index">
									<template v-if="item.name != '未完成'">
										<i :style="{background: item.itemStyle.color}"></i>
										<span class="name">{{item.name}}</span>
										<div class="value">{{item.value}}</div>
									</template>
									<template v-else>
										<el-popover placement="top" width="600" trigger="click">
											<el-table :data="chart4Options.tableValue">
												<el-table-column width="300" property="label"
													label="任务名称"></el-table-column>
												<el-table-column width="200" property="taskNo"
													label="任务编号"></el-table-column>
												<el-table-column width="100" property="status"
													label="状态"></el-table-column>
											</el-table>
											<div style="display: flex;flex-direction: row;align-items: center;padding: 0;cursor: pointer;"
												slot="reference">
												<i :style="{background: item.itemStyle.color}"></i>
												<span class="name">{{item.name}}</span>
												<div class="value">{{item.value}}</div>
											</div>
										</el-popover>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cardK">
				<div class="card">
					<div class="titleK">
						<div class="title">
							品质核查概览（{{getSelect(tabIndex3)}}）
						</div>
					</div>
					<el-menu :default-active="tabIndex3" @select="tabIndex3 = $event" class="el-menu-demo"
						mode="horizontal" background-color="transparent" text-color="#FFF" active-text-color="#3ED4EB">
						<el-menu-item :index="0">全部</el-menu-item>
						<el-menu-item :index="1">六月</el-menu-item>
						<el-menu-item :index="2">七月</el-menu-item>
						<el-menu-item :index="3">八月</el-menu-item>
					</el-menu>
					<div class="content contentZ1">
						<div class="gsItem">
							<div class="gsTitle">
								<span>任务总数</span>
								<img src="@/assets/pzhc/1.png" alt="">
							</div>
							<div class="num">
								{{tabValue3[tabIndex3].value1.v1}}
							</div>
							<div class="gsInners">
								<div class="gsItemIn">
									<p>同比</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue3[tabIndex3].value1.v2}}%</div>
								</div>
								<div class="gsItemIn">
									<p>环比</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue3[tabIndex3].value1.v3}}%</div>
								</div>
							</div>
						</div>
						<div class="gsItem">
							<div class="gsTitle">
								<span>任务完成数</span>
								<img src="@/assets/pzhc/2.png" alt="">
							</div>
							<div class="num">
								{{tabValue3[tabIndex3].value2.v1}}
							</div>
							<div class="gsInners">
								<div class="gsItemIn">
									<p>同比</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue3[tabIndex3].value2.v2}}%</div>
								</div>
								<div class="gsItemIn">
									<p>环比</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue3[tabIndex3].value2.v3}}%</div>
								</div>
							</div>
						</div>
						<div class="gsItem">
							<div class="gsTitle">
								<span>完成率</span>
								<img src="@/assets/pzhc/3.png" alt="">
							</div>
							<div class="num">
								{{tabValue3[tabIndex3].value3.v1}}%
							</div>
							<div class="gsInners">
								<div class="gsItemIn">
									<p>较上季度</p>
									<div class="success"><img class="jiantou" src="@/assets/up.png"
											alt="" />{{tabValue3[tabIndex3].value3.v2}}%</div>
								</div>
							</div>
						</div>
						<el-popover placement="left" width="600" trigger="click" style="width: 48%;">
							<el-table :data="tabValue3[tabIndex3].value4.v3">
								<el-table-column width="300" property="label" label="任务名称"></el-table-column>
								<el-table-column width="200" property="taskNo" label="任务编号"></el-table-column>
								<el-table-column width="100" property="status" label="状态"></el-table-column>
							</el-table>
							<div class="gsItem active" slot="reference" style="width: 100%;height: calc(100% - 20px);">
								<div class="gsTitle">
									<span>逾期率</span>
									<img src="@/assets/pzhc/4.png" alt="">
								</div>
								<div class="num">
									{{tabValue3[tabIndex3].value4.v1}}%
								</div>
								<div class="gsInners">
									<div class="gsItemIn ">
										<p>较上季度</p>
										<div class="success"><img class="jiantou" src="@/assets/up.png"
												alt="" />{{tabValue3[tabIndex3].value4.v2}}%
										</div>
									</div>
								</div>
							</div>
						</el-popover>
					</div>
				</div>
			</div>
		</div>

		<div class="bottom">
			<div class="cardK">
				<div class="card">
					<div class="title">
						综合巡逻
					</div>
					<div class="content" id="chart5" ref="chart5"></div>
				</div>
			</div>
			<div class="cardK">
				<div class="card">
					<div class="title">
						部门异常任务数量
					</div>
					<div class="content" id="chart6" ref="chart6"></div>
				</div>
			</div>
			<div class="cardK">
				<div class="card">
					<div class="title">
						品质问题跟踪
					</div>
					<div class="content" id="chart7" ref="chart7"></div>
				</div>
			</div>


		</div>
	</div>
</template>

<script>
	import {
		chart1,
		chart2,
		chart3,
		chart4,
		chart5,
		chart6,
		chart7,
	} from '../common/pzhcOptions.js';

	import {
		tabValue1,
		tabValue3,
		contentValue
	} from '../common/pzhcValue.js'

	import * as echarts from 'echarts';


	export default {
		data() {
			return {
				chart1: null,
				chart1Options: chart1,
				chart2: null,
				chart2Options: chart2,
				chart3: null,
				chart3Options: chart3,
				chart4: null,
				chart4Options: chart4,
				chart5: null,
				chart6: null,
				chart7: null,
				tabIndex1: 0,
				tabIndex2: 0,
				tabIndex3: 0,
				tabValue1,
				tabValue3,
				tableValue2: []
			}
		},
		created() {
			this.$nextTick(_ => {
				this.setChart();
			})
			let _self = this;
			window.addEventListener('resize', function() {
				clearTimeout(_self.timer)
				_self.timer = setTimeout(_ => {
					_self.resize()
				}, 1000)
			})
		},
		methods: {
			getSelect(index){
				let items = ['第三季度','六月','七月','八月']
				return items[index];
			},
			resize() {
				this.chart1.resize();
				this.chart2.resize();
				this.chart3.resize();
				this.chart4.resize();
				this.chart5.resize();
				this.chart6.resize();
				this.chart7.resize();
			},
			setChart() {
				console.log(1111)
				this.chart1 = echarts.init(this.$refs.chart1, null, {
					devicePixelRatio: 2.5
				});

				this.chart2 = echarts.init(this.$refs.chart2, null, {
					devicePixelRatio: 2.5
				});

				this.chart3 = echarts.init(this.$refs.chart3, null, {
					devicePixelRatio: 2.5
				});

				this.chart4 = echarts.init(this.$refs.chart4, null, {
					devicePixelRatio: 2.5
				});
				this.setContent(0)

				this.chart5 = echarts.init(this.$refs.chart5, null, {
					devicePixelRatio: 2.5
				});
				this.chart5.setOption(chart5);

				this.chart6 = echarts.init(this.$refs.chart6, null, {
					devicePixelRatio: 2.5
				});
				this.chart6.setOption(chart6);

				this.chart7 = echarts.init(this.$refs.chart7, null, {
					devicePixelRatio: 2.5
				});
				this.chart7.setOption(chart7);
			},
			setContent(e){
				this.tabIndex2 = e;
				
				
				
				this.chart1Options.series[0].data = this.chart1Options.series[0].data.map((item,index)=>{
					item.value = contentValue[this.tabIndex2].v1[index]
					return item
				})
				this.chart1Options.tableValue = contentValue[this.tabIndex2].v1Value;
				this.chart2Options.series[0].data = this.chart2Options.series[0].data.map((item,index)=>{
					item.value = contentValue[this.tabIndex2].v2[index]
					return item
				})
				this.chart2Options.tableValue = contentValue[this.tabIndex2].v2Value;
				this.chart3Options.series[0].data = this.chart3Options.series[0].data.map((item,index)=>{
					item.value = contentValue[this.tabIndex2].v3[index]
					return item
				})
				this.chart3Options.tableValue = contentValue[this.tabIndex2].v3Value;
				this.chart4Options.series[0].data = this.chart4Options.series[0].data.map((item,index)=>{
					item.value = contentValue[this.tabIndex2].v4[index]
					return item
				})
				this.chart4Options.tableValue = contentValue[this.tabIndex2].v4Value;
				
				
				this.chart1.setOption(this.chart1Options);
				this.chart2.setOption(this.chart2Options);
				this.chart3.setOption(this.chart3Options);
				this.chart4.setOption(this.chart4Options);
				
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	$main-color: #3ED4EB;
	$main2-color: #2b9ae4;
	$success: #abff9b;
	$danger: #BD1B3C;
	$blue: #2B9AE4;

	div {
		box-sizing: border-box;
	}

	.pzhc {
		flex: 1;
		padding: 20px 26px 0;
		display: flex;
		overflow: hidden;

		.top {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: stretch;
			height: 60%;
		}

		.bottom {
			height: 38%;
			padding-top: 20px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: stretch;
		}

		.cardK {
			width: 33%;
			max-width: 33%;
			padding: 0 10px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.card {
				width: 100%;
				flex: 1;
				overflow: hidden;
				// background: linear-gradient(to right, #16213A 0%, #081E2F 50%, #16213A 100%);
				padding: 20px 18px;
				margin-bottom: 15px;
				display: flex;
				flex-direction: column;
				transition: all .2s;

				&:last-child {
					margin-bottom: 0;
				}

				.titleK {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					margin-bottom: -40px;

					.tabs {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: stretch;
						width: 138px;
						height: 34px;

						div {
							flex: 1;
							border: 1px solid #245898;
							margin-right: -1px;
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: 16px;
							line-height: 100%;
							color: #b7bcc4;
							cursor: pointer;
							transition: all .2s;
							background: linear-gradient(to right, transparent 0%, transparent 50%, transparent 100%);

							&:hover {
								color: #FFF;
							}

							&.on {
								background: linear-gradient(to right, #1e4578 0%, transparent 50%, #1e4578 100%);
								color: #FFF;
							}
						}
					}
				}

				.title {
					&:before {
						content: '';
						display: flex;
						width: 14px;
						height: 14px;
						border: 2px solid #57C9DE;
						background: #0667D4;
						margin-right: 12px;
					}

					display: flex;
					font-size: 18px;
					color: #FFF;
					flex-direction: row;
					justify-content: flex-start;
					align-items: center;
					font-weight: 500;
					user-select: none;
					line-height: 20px;
				}

				.content {
					width: 100%;
					flex: 1;
				}

				.chartList {
					display: flex;
					height: 90%;
					flex-direction: row;
					justify-content: space-between;
					align-items: stretch;

					.pzY {
						flex: 1;

						.chart {
							width: 100%;
							height: 80%;
						}

						.pzYlist {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;
							flex-wrap: wrap;

							.item {
								display: flex;
								flex-direction: row;
								justify-content: center;
								align-items: center;
								width: 50%;

								i {
									display: flex;
									width: 12px;
									height: 12px;
									border-radius: 50%;
								}

								.name {
									color: $main-color;
									font-size: 14px;
									line-height: 20px;
									padding-left: 6px;
								}

								.value {
									font-size: 22px;
									line-height: 24px;
									padding-left: 6px;
									width: 40px;
								}
							}
						}
					}

					.hr {
						border-right: 1px dotted #949494;
						height: 80%;
						margin-top: 10%;
					}
				}







				.contentZ1 {
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: stretch;
					flex: 1;
					flex-wrap: wrap;
					padding-top: 20px;

					.gsItem {
						width: 48%;
						background: rgba(36, 54, 84, .5);
						// margin: 10px 15px 0;
						margin-bottom: 20px;
						padding: 20px 30px;
						display: flex;
						flex-direction: column;
						justify-content: space-around;
						transition: all .2s;
						transform: scale(1, 1);

						&.active {
							cursor: pointer;
						}

						&.active:active {
							transform: scale(.95, .95);
						}

						&:hover {
							background: rgba(36, 54, 84, 1);
						}

						.gsTitle {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;

							span {
								font-size: 18px;
								color: $main2-color;
							}

							img {
								// width: 20px;
								width: 30px;
							}
						}

						.num {
							font-size: 40px;
							line-height: 50px;
							color: #FFF;
							font-weight: 500;
						}

						.gsInners {
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							align-items: center;

							.gsItemIn {
								flex: 1;
								display: flex;
								flex-direction: column;

								&.gsItemIn2 {
									flex-direction: row;
									justify-content: space-between;
								}

								.jiantou {
									width: 10px;
									margin-right: 4px;
								}

								p {
									color: $main-color;
									font-size: 16px;
									line-height: 30px;
								}

								>div {
									font-size: 16px;
									line-height: 22px;
									display: flex;
									flex-direction: row;
									justify-content: flex-start;
									align-items: center;

									&.success {
										color: $success;
									}

									&.danger {
										color: $danger;
									}
								}
							}
						}
					}
				}



			}
		}
	}


	.el-menu {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}
</style>